import React from 'react';

const FloorplanDeal = () => {
  return (
    <div className="floorplan-deal-text">Move-in Deal!</div>
  );
};

export default FloorplanDeal;